import { updateObject } from '../../utils/utility';

const initialState = {};

const setOrderDetails = (state = initialState, action) => {
    const order = action.data;
    return updateObject(state, { order });
};

const updateFinancialDetail = (state = initialState, action) => {
    const { value, columnName, rowIndex } = action;
    const { financialData } = state.order;
    financialData[rowIndex] = { ...financialData[rowIndex], [columnName]: value };
    return updateObject(state, { financialData });
};

const reducer = (state = initialState, action) => {
    if (action.type === "SET_ORDER_DETAILS") {
        return setOrderDetails(state, action);
    }
    else if (action.type === "UPDATE_FINANCIAL_DETAILS") {
        return updateFinancialDetail(state, action);
    }
    return state;
}

export default reducer;